import { useCallback, useState } from 'react';

function readDismissed(storageKey) {
  try {
    return localStorage.getItem(storageKey) === '1';
  } catch {
    return false;
  }
}

/**
 * Persist banner dismissal in localStorage (per browser).
 * @param {string} storageKey Stable key, e.g. `staff-upload-banner-v1`
 */
export default function useDismissibleBanner(storageKey) {
  const [dismissed, setDismissed] = useState(() => readDismissed(storageKey));

  const dismiss = useCallback(() => {
    setDismissed(true);
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      /* ignore quota / private mode */
    }
  }, [storageKey]);

  return { dismissed, dismiss };
}
